<template>
	<div class="" style="height:100%">
		<div class="selectionBar">
			<div class="flex flex-ai-c flex-wrap">
				<label>场景：</label>
                <el-select v-model="select.state_id" clearable placeholder="商品状态" size="small" style="width:120px;margin-right:5px;" @change="curr=1;getList()">
					<el-option v-for="item in jlList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-input placeholder="商品标题" v-model="searchValue" size="small" class="input-with-select" style="width:300px;margin-left:auto">
					<el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
				</el-input>
				
				<el-date-picker v-model="select.date" size="small" style="width:350px;margin-right:5px;margin-left:auto" type="datetimerange" range-separator="至" start-placeholder="秒杀时间" end-placeholder="筛选" value-format="yyyy-MM-dd HH:mm:ss" @change="curr=1;getList()">
				</el-date-picker>
			</div>
		</div>
		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 140px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
				<el-table-column prop="name" label="商品标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="main_pic" label="商品图片" width="120" align="center">
					<template slot-scope="scope">
						<el-image :src="getImgUrl(scope.row.main_pic)" fit="cover" class="main_pic" :preview-src-list="[domain + '/' + scope.row.main_pic]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="spike_price" label="秒杀价格" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="number" label="库存" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sales_number" label="销量" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="status" label="秒杀状态" width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="start_time" label="开始时间" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="end_time" label="结束时间" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column fixed="right" label="操作" width="120" align="center">
					<template slot-scope="scope">
						<!-- <el-button @click="showDetail(scope.row.id)" type="text" size="small">查看</el-button>
						<el-button @click="del(scope.row)" type="text" size="small">删除</el-button> -->
						<el-button-group>
							<el-button type="primary" icon="el-icon-zoom-in" size="small" @click="showDetail(scope.row.goods_id)"></el-button>
							<el-button :disabled="!$permission.is('/skip_del')" type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				jlList: [{
					id: '1',
					name: '进行中'
				}, {
					id: '2',
					name: '未开始'
				}, {
					id: '3',
					name: '已结束'
				}],
				select: {
					state_id: '', //商品状态
					date: []
				},
				
				searchValue: '',
				curr: 1, //页码
				row: 20, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				if (this.select.date == null) {
					this.select.date = []
				}
				this.http.post('/admin/spike/getList', {
					curr: this.curr,
					row: this.row,
					wd: this.searchValue,
					status: this.select.state_id,
					s_time: this.select.date.length > 0 ? this.select.date[0] : '',
					e_time: this.select.date.length > 0 ? this.select.date[1] : '',
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},

			showDetail(id) {
				this.http.post('/admin/goods/read', {
					id
				}).then(res => {
					this.$router.push({
						path: "spAdd",
						query: {
							show: true,
							row: JSON.stringify(res)
						}
					});
				});
			},
			
			//删除
			del(row) {
				this.$confirm(`确定删除吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.http.post('/admin/spike/delete', {
						id: row.id,
					}).then(() => {
						this.getList();
						this.$message({
							type: 'success',
							message: '已删除!'
						});
					})
				})
			},
			
			// 图片转换
			getImgUrl(item) {
				var url = this.domain + '/' + item;
				return url;
			},

			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			},
		}
	}
</script>
